import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { MemberService } from '@app/core/members/member.service';
import { SettingsService } from '@app/core/settings/settings.service';
import { arrayEquals } from '@app/shared/utils/array_equals';

@Injectable()
export class MissingPropertiesService {
  private memberService = inject(MemberService);
  private settingsService = inject(SettingsService);


  public getMissingPropertyNames(): Observable<string[]> {
    return this.getMemberPropertiesNames().pipe(
      map((properties) => this.getRequiredPropertyNames().filter(name => !properties.includes(name))),
    );
  }

  private getMemberPropertiesNames(): Observable<string[]> {
    return this.memberService.get()
      .pipe(
        filter(Boolean),
        map((member) => member.properties),
        map(properties => properties ? Object.keys(properties) : []),
        distinctUntilChanged((a, b) => arrayEquals(a, b)),
      );
  }

  private getRequiredPropertyNames(): string[] {
    return this.settingsService.settings.schema.required;
  }
}
